module.exports = __webpack_public_path__ + "img/cert2.ac590438.png";